/**
 * Show & Hide spinner overlay
 */
function mcs_triggerSpinner() {
	jQuery('.js-spinner').show();
}
var mcs_hideSpinner = function () {
	setTimeout( function(){
		jQuery('.js-spinner').hide();
	}, 100 );
}